export type AISubtaskType = 'image' | 'question'

/** Raw LLM payload: `title` + `desc` for an image subtask, `question` for an open question. */
export interface IAIGeneratedSubtask {
  title?: string
  desc?: string
  question?: string
}
/** Ignore unknown fields and malformed values instead of letting renderers consume transport data. */
export function parseGeneratedSubtask(raw: string | null | undefined): IAIGeneratedSubtask | null {
  try {
    const result: unknown = raw ? JSON.parse(raw) : null
    if (!result || typeof result !== 'object' || Array.isArray(result)) return null
    const data = result as Record<string, unknown>
    return {
      ...(typeof data.title === 'string' ? { title: data.title } : {}),
      ...(typeof data.desc === 'string' ? { desc: data.desc } : {}),
      ...(typeof data.question === 'string' ? { question: data.question } : {}),
    }
  } catch {
    return null
  }
}

export function hasGeneratedContent(result: IAIGeneratedSubtask, type: AISubtaskType): boolean {
  return !!(result.title?.trim() || result.desc?.trim() || (type === 'question' && result.question?.trim()))
}
